import type { Component } from '@wix/thunderbolt-becky-types'
import { pinnedLayerDataItemToCss } from '@wix/thunderbolt-commons'
import { mapValues, merge } from 'lodash'
import { createCssCompNode } from '../cssCompNode'
import type { SelectorObj } from '../../shared.types'
import type { FeatureRefs } from '../cssFeatures.types'

export const pinnedLayer = createCssCompNode('responsiveLayout', 'pinnedLayer', {
	getDependencies: (component: Component, refs: FeatureRefs<'responsiveLayout'>) => ({
		breakpointsToLayouts: refs.compLayouts(component),
		hasResponsiveLayout: refs.hasResponsiveLayout(component),
	}),
	toViewItem: (_component, { breakpointsToLayouts, hasResponsiveLayout }) => {
		if (!hasResponsiveLayout) {
			return null
		}

		return mapValues(breakpointsToLayouts, (variantsToLayouts) =>
			mapValues(variantsToLayouts, (layoutDataItems) => {
				const itemsCss = layoutDataItems.map((item) =>
					item.type === 'FixedItemLayout' ? pinnedLayerDataItemToCss(item) : null
				)
				const mergedCss: SelectorObj = merge({}, ...itemsCss)
				return mergedCss
			})
		)
	},
})
